import { useFormState } from 'react-final-form';

import DisabledFormSection from 'components/DisabledFormSection';
import FormRow from 'components/FormRow';
import FormSection from 'components/FormSection';
import { TextAreaWithField } from 'components/TextArea';
import { hausbankFields, HausbankSections, PurposeOptions } from 'hausbank/inquiry/fields';
import { HausbankPurposeKind } from 'hausbank/inquiry/steps/financingNeed/sections/purposeSection/purposeKinds/PurposeKind';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { translations } from 'new/form/common/types';
import { FieldTypes } from 'new/form/common/types';
import { Condition } from 'new/form/Condition';
import { TextComponent } from 'theme/components/Text';
import { useTranslations } from 'utils/hooks/useTranslations';

const { projectDescription } = hausbankFields.financingNeedPage.purposeSection;

export const PurposeSection = () => {
  const t = useTranslations();
  const { values } = useFormState<FieldTypes<InquiryType.hausbank>>();
  const subheading =
    translations.inquiryType.hausbank.pages.financingNeed.sections.purpose.subheadings
      .additionalInformation;
  const { title } = translations.inquiryType.hausbank.pages.financingNeed.sections.purpose;
  const subheadingText = t(subheading);
  const selectedPurposes = values?.financingNeedPage?.purposeSection?.purposeKind ?? [];
  const isOtherSelected =
    Array.isArray(selectedPurposes) && selectedPurposes.some((p) => p?.id === PurposeOptions.other);

  return (
    <Condition<HausbankSections>
      validation={'financingNeedSection'}
      fallback={
        <DisabledFormSection
          sectionNumber={2}
          placeholder={t(translations.inquiryType.hausbank.sectionFallback)}
          title={t(title)}
        />
      }
      sectionTitle={t(title)}
    >
      <FormSection title={t(title)} sectionNumber={2}>
        <TextComponent color={'text.tertiary'} mb={12}>
          {subheadingText}
        </TextComponent>
        <FormRow>
          <HausbankPurposeKind caption={subheadingText} />
        </FormRow>
        <FormRow>
          <TextAreaWithField name={projectDescription} optional={!isOtherSelected} />
        </FormRow>
      </FormSection>
    </Condition>
  );
};
